/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
//Used in ui-permit, ui-internal-permit-issuance, ui-account.  Consider moving to shared-comps folder

import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'sarsaparilla';
import { errorsToStringList, getNewId } from '../utils/utilsNew';

export default class ErrorNotification extends React.PureComponent {
    static propTypes = {
        errorHeader: PropTypes.string,
        errors: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    error: PropTypes.string,
                }),
            ])
        ),
        className: PropTypes.string,
        innerRef: PropTypes.shape({
            current: PropTypes.instanceOf(Element),
        }),
    };
    render() {
        const { errorHeader, errors, className, innerRef } = this.props;
        const errorsList = errorsToStringList(errors);
        const header = errorHeader || 'Errors:';

        return (
            <div
                tabIndex={-1}
                style={{ outline: 'none' }}
                ref={innerRef}
                aria-live="polite"
            >
                {errorsList.length > 0 && (
                    <Alert
                        className={className || 'permit-error-notification'}
                        heading={header}
                        type="error"
                        key={getNewId()}
                        hasAriaLive
                    >
                        <ul>
                            {errorsList.map((err) => (
                                <li key={getNewId()}>
                                    <div className="permit-validation">{err}</div>
                                </li>
                            ))}
                        </ul>
                    </Alert>
                )}
            </div>
        );
    }
}
